// Auto-generated by Emakloon Patch Manager
import { ModuleManifest } from './types';
import MAKLOON_MANIFEST from '@/modules/makloon';

export const ACTIVE_ADDONS: ModuleManifest[] = [MAKLOON_MANIFEST];
